import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../../../../../helpers/custom-prop-types';
import FilePdfIcon from '../../../../../../Icon/Svg/FilePdfIcon';
import FilePptxIcon from '../../../../../../Icon/Svg/FilePptxIcon';
const UploadHistoryIcon = (props) => {
    const { className, fileExtension } = props;
    if (fileExtension === 'pdf') {
        return _jsx(FilePdfIcon, { className: className });
    }
    if (fileExtension === 'pptx') {
        return _jsx(FilePptxIcon, { className: className });
    }
    return null;
};
UploadHistoryIcon.propTypes = {
    className: propStr().isRequired,
    fileExtension: propStr().isRequired,
};
export default UploadHistoryIcon;
